import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  title: '',
  message: '',
  type: 'confirm', // confirm | success | error
  onConfirm: null
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (state, action) => {
      return { ...state, show: true, ...action.payload };
    },
    hideModal: () => initialState
  }
});

export const { showModal, hideModal } = modalSlice.actions;
export default modalSlice.reducer;
